import { useRef } from 'react';
import { Card, CardContent } from '@/components/ui/card';

// Mixed content array - images, text, quotes, GIFs, Spotify embeds
const contentBlocks = [
  {
    type: 'title',
    content: {
      title: 'Carbon',
      subtitle: 'Pages',
      byline: 'A Collection of Plays',
      author: 'Daniel Gavilovski',
    },
    size: 'large',
  },
  {
    type: 'image',
    src: '/images/image-01.png',
    caption: '',
    size: 'large',
  },
  {
    type: 'image',
    src: '/images/image-02.jpg',
    caption: '',
    size: 'medium',
  },
  {
    type: 'image',
    src: '/images/image-03.png',
    caption: '',
    size: 'small',
  },
  {
    type: 'image',
    src: '/images/image-04.jpg',
    caption: '',
    size: 'small',
  },
  {
    type: 'quote',
    content: 'Many types of people will have to disappear ... Many people will want to join us. Possibly we will conquer the whole world. People will die young but it will be fun. We will burn the corpses of the heroes.',
    size: 'small',
  },
  {
    type: 'text',
    content: '"My daughter was my treasure. But when was that... What am I saying? My daughter is alive. Inside this box! ... my box ... my daughter ... "',
    title: '',
    size: 'medium',
  },
  {
    type: 'image',
    src: '/images/image-05.jpg',
    caption: '',
    size: 'medium',
  },
  {
    type: 'image',
    src: '/images/vintage-greek.gif',
    caption: '',
    size: 'large',
  },
  {
    type: 'image',
    src: '/images/image-06.jpg',
    caption: '',
    size: 'small',
  },
  {
    type: 'image',
    src: '/images/image-07.png',
    caption: '',
    size: 'medium',
  },
  {
    type: 'quote',
    content: 'There is no worse case scenario than what is happening now.',
    size: 'small',
  },
  {
    type: 'image',
    src: '/images/image-08.png',
    caption: '',
    size: 'large',
  },
  {
    type: 'image',
    src: '/images/image-09.jpg',
    caption: '',
    size: 'small',
  },
  {
    type: 'image',
    src: '/images/image-10.jpg',
    caption: '',
    size: 'medium',
  },
  {
    type: 'text',
    content: 'Until now I have never really lived! Life on earth is a creeping, crawling business. It is in the air that one feels the glory of being a man and of conquering the elements. There is an exquisite smoothness of motion and the joy of gliding through space. It is wonderful!',
    title: '',
    size: 'medium',
  },
  {
    type: 'image',
    src: '/images/image-11.jpg',
    caption: '',
    size: 'large',
  },
  {
    type: 'image',
    src: '/images/image-12.webp',
    caption: '',
    size: 'medium',
  },
  {
    type: 'image',
    src: '/images/image-13.jpg',
    caption: '',
    size: 'small',
  },
  {
    type: 'image',
    src: '/images/image-14.png',
    caption: '',
    size: 'small',
  },
  {
    type: 'spotify',
    spotifyId: '7dyEd2Chdd81YnUZQPD3bL',
    title: 'No Weapon',
    description: 'Something about snow',
    size: 'medium',
  },
  {
    type: 'image',
    src: '/images/image-15.jpg',
    caption: '',
    size: 'large',
  },
  {
    type: 'image',
    src: '/images/image-16.jpg',
    caption: '',
    size: 'small',
  },
  {
    type: 'image',
    src: '/images/image-17.jpg',
    caption: '',
    size: 'medium',
  },
  {
    type: 'quote',
    content: 'We are the most courageous party, we are the most uncontrolled. We want to create a climate of political freedom and so we are very irritating to the Kremlin. We make the government crazy.',
    size: 'small',
  },
  {
    type: 'image',
    src: '/images/image-18.jpg',
    caption: '',
    size: 'large',
  },
  {
    type: 'image',
    src: '/images/image-19.jpg',
    caption: '',
    size: 'medium',
  },
  {
    type: 'image',
    src: '/images/image-20.jpg',
    caption: '',
    size: 'small',
  },
  {
    type: 'text',
    content: 'The tragedy of my life lies purely in the fact that I am a very ordinary, ordinary person',
    title: '',
    size: 'medium',
  },
  {
    type: 'image',
    src: '/images/image-21.jpg',
    caption: '',
    size: 'medium',
  },
  {
    type: 'image',
    src: '/images/image-22.jpg',
    caption: '',
    size: 'small',
  },
  {
    type: 'image',
    src: '/images/image-23.jpg',
    caption: '',
    size: 'large',
  },
  {
    type: 'spotify',
    spotifyId: '5Jc50JBajzUtDxowbfbeRe',
    title: 'What Hasnt He Got',
    description: 'Jeopardy',
    size: 'medium',
  },
  {
    type: 'image',
    src: '/images/image-24.jpg',
    caption: '',
    size: 'small',
  },
  {
    type: 'image',
    src: '/images/image-25.jpg',
    caption: '',
    size: 'medium',
  },
  {
    type: 'image',
    src: '/images/image-26.jpg',
    caption: '',
    size: 'small',
  },
  {
    type: 'image',
    src: '/images/image-27.jpg',
    caption: '',
    size: 'large',
  },
  {
    type: 'text',
    content: "You can't live here. Here you can only fight, get sick, survive, make your way somewhere with battles and losses. There is no tomorrow here. At any moment you can be beaten, robbed, tools thrown out the train window...",
    title: '',
    size: 'medium',
  },
  {
    type: 'image',
    src: '/images/image-28.jpg',
    caption: '',
    size: 'medium',
  },
  {
    type: 'image',
    src: '/images/image-29.jpg',
    caption: '',
    size: 'small',
  },
  {
    type: 'image',
    src: '/images/image-30.gif',
    caption: '',
    size: 'medium',
  },
  {
    type: 'image',
    src: '/images/image-31.jpg',
    caption: '',
    size: 'small',
  },
  {
    type: 'image',
    src: '/images/image-32.jpg',
    caption: '',
    size: 'large',
  },
  {
    type: 'spotify',
    spotifyId: '7wIRGu8yg3FEpUIFEhQ8g8',
    title: 'Is This Play About Us',
    description: 'Shop Theme',
    size: 'medium',
  },
  {
    type: 'image',
    src: '/images/image-33.jpg',
    caption: '',
    size: 'small',
  },
  {
    type: 'image',
    src: '/images/image-34.png',
    caption: '',
    size: 'large',
  },
  {
    type: 'image',
    src: '/images/image-35.png',
    caption: '',
    size: 'medium',
  },
  {
    type: 'image',
    src: '/images/image-36.png',
    caption: '',
    size: 'small',
  },
  {
    type: 'image',
    src: '/images/image-37.jpg',
    caption: '',
    size: 'medium',
  },
  {
    type: 'image',
    src: '/images/image-38.jpg',
    caption: '',
    size: 'large',
  },
  {
    type: 'image',
    src: '/images/image-39.webp',
    caption: '',
    size: 'small',
  },
  {
    type: 'image',
    src: '/images/image-40.jpg',
    caption: '',
    size: 'medium',
  },
  {
    type: 'quote',
    content: 'The American empire should be destroyed.',
    size: 'small',
  },
  {
    type: 'image',
    src: '/images/image-01.png',
    caption: '',
    size: 'medium',
  },
];

export const MasonryContent = () => {
  const blockRefs = useRef([]);

  const renderBlock = (block, index) => {
    const baseClasses = ''; // No animation classes

    switch (block.type) {
      case 'title':
        return (
          <div
            ref={(el) => (blockRefs.current[index] = el)}
            className={`${baseClasses} col-span-full min-h-screen flex items-center justify-center text-center`}
          >
            <div>
              <h1 className="text-9xl md:text-[12rem] lg:text-[16rem] font-normal mb-12 tracking-tight leading-none brutalist-text">
                <span className="block text-foreground">{block.content.title}</span>
                <span className="block text-primary gold-glow mt-6">{block.content.subtitle}</span>
              </h1>
              <p className="text-2xl md:text-3xl text-muted-foreground font-normal tracking-wider mb-6 mt-12 brutalist-text">
                {block.content.byline}
              </p>
              <div className="mt-16">
                <div className="w-20 h-px bg-primary/50 mx-auto mb-6" />
                <p className="text-sm uppercase tracking-[0.3em] text-primary/80 mb-4 font-semibold digital-text">
                  Written by
                </p>
                <p className="text-3xl font-normal text-foreground brutalist-text">
                  {block.content.author}
                </p>
              </div>
            </div>
          </div>
        );

      case 'image':
        return (
          <div
            ref={(el) => (blockRefs.current[index] = el)}
            className={`${baseClasses} group overflow-hidden`}
          >
            <img
              src={block.src}
              alt={block.caption || 'Carbon Pages'}
              className="w-full h-auto transition-all duration-700 hover:scale-[1.02]"
              loading="lazy"
              decoding="async"
            />
          </div>
        );

      case 'text':
        return (
          <div
            ref={(el) => (blockRefs.current[index] = el)}
            className={`${baseClasses} p-6 md:p-10 flex items-center justify-center`}
          >
            <p className="text-2xl md:text-3xl lg:text-4xl font-normal text-foreground leading-snug">
              {block.content}
            </p>
          </div>
        );

      case 'quote':
        return (
          <div
            ref={(el) => (blockRefs.current[index] = el)}
            className={`${baseClasses} p-6 md:p-10 flex items-center justify-center`}
          >
            <p className="text-2xl md:text-3xl lg:text-4xl font-normal text-foreground leading-snug italic">
              {block.content}
            </p>
          </div>
        );

      case 'spotify':
        return (
          <div
            ref={(el) => (blockRefs.current[index] = el)}
            className={baseClasses}
          >
            <Card className="bg-card/50 border-primary/20 overflow-hidden hover:border-primary/40 transition-colors">
              <CardContent className="p-0">
                <iframe
                  src={`https://open.spotify.com/embed/playlist/${block.spotifyId}?utm_source=generator&theme=0`}
                  width="100%"
                  height="352"
                  frameBorder="0"
                  allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
                  loading="lazy"
                  title={block.title}
                />
                <div className="p-4 bg-card border-t border-primary/20">
                  <h3 className="text-sm font-semibold text-primary">
                    {block.title}
                  </h3>
                  <p className="text-xs text-muted-foreground mt-1">
                    {block.description}
                  </p>
                </div>
              </CardContent>
            </Card>
          </div>
        );

      default:
        return null;
    }
  };

  return (
    <div className="max-w-[1400px] mx-auto px-8 lg:px-12 py-32">
      {/* Masonry Grid - responsive with better mobile performance */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4 md:gap-6 auto-rows-auto">
        {contentBlocks.map((block, index) => {
          // Size classes for different grid spans
          let sizeClass = '';
          switch (block.size) {
            case 'large':
              sizeClass = 'md:col-span-2 lg:col-span-3 xl:col-span-4';
              break;
            case 'medium':
              sizeClass = 'md:col-span-2 lg:col-span-2';
              break;
            case 'small':
            default:
              sizeClass = 'col-span-1';
              break;
          }

          return (
            <div key={index} className={sizeClass}>
              {renderBlock(block, index)}
            </div>
          );
        })}
      </div>
    </div>
  );
};